let audioCtx = null;
let loopInterval = null;

const getAudioContext = async () => {
  if (!audioCtx) {
    try {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } catch {
      return null;
    }
  }
  if (audioCtx.state === 'suspended') {
    try {
      await audioCtx.resume();
    } catch {
      return null;
    }
  }
  return audioCtx;
};

// Desbloquea el AudioContext ante la primera interaccion del usuario (politica de autoplay).
export const unlockAudio = () => {
  getAudioContext();
};

const tone = (ctx, start, freq, dur, gainVal, type) => {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type || 'square';
  osc.frequency.setValueAtTime(freq, start);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(gainVal, start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(start);
  osc.stop(start + dur + 0.05);
};

// Sonido 'normal' (doble tono): distinto segun el origen del pedido.
const playNormal = (ctx, origen) => {
  const now = ctx.currentTime;
  if (origen === 'tienda') {
    // Tienda: "ding-dong" grave (timbre de salon), claro y audible.
    tone(ctx, now, 659.25, 0.20, 0.95, 'square');
    tone(ctx, now + 0.22, 493.88, 0.26, 0.95, 'square');
  } else {
    // Online: doble tono agudo.
    tone(ctx, now, 880, 0.16, 0.9, 'square');
    tone(ctx, now + 0.2, 1174.66, 0.22, 0.9, 'square');
  }
};

// Sonido 'critica' (alarma de 3 tonos): distinto segun el origen del pedido.
const playCritica = (ctx, origen) => {
  const now = ctx.currentTime;
  if (origen === 'cocina_tienda') {
    // "Salio de cocina" (tienda -> armado): arpegio descendente G5-E5-A4 con onda
    // triangle, distinto de online (cuadrada aguda) y de tienda (cuadrada grave).
    for (let i = 0; i < 3; i += 1) {
      const t = now + i * 0.3;
      tone(ctx, t, 783.99, 0.16, 0.95, 'triangle');
      tone(ctx, t + 0.13, 587.33, 0.16, 0.95, 'triangle');
      tone(ctx, t + 0.26, 440.00, 0.20, 0.95, 'triangle');
    }
  } else if (origen === 'tienda') {
    for (let i = 0; i < 3; i += 1) {
      const t = now + i * 0.24;
      tone(ctx, t, 523.25, 0.18, 0.95, 'square');
      tone(ctx, t + 0.12, 392.00, 0.18, 0.95, 'square');
    }
  } else {
    for (let i = 0; i < 3; i += 1) {
      const t = now + i * 0.22;
      tone(ctx, t, 880, 0.16, 0.95, 'square');
      tone(ctx, t + 0.11, 660, 0.16, 0.95, 'square');
    }
  }
};

// Reproduce UNA rafaga de sonido (doble tono o alarma de 3 tonos) segun severidad y
// origen ('tienda' | 'online' | undefined -> online).
export const playNotificationSound = (severidad = 'normal', origen) => {
  getAudioContext().then((ctx) => {
    if (!ctx) return;
    try {
      if (severidad === 'critica') playCritica(ctx, origen);
      else playNormal(ctx, origen);
    } catch {}
  });
};

// Reproduce el sonido `veces` (por defecto 3) y se detiene SOLO. Sustituye el loop
// permanente. Una nueva llamada corta la secuencia anterior y arranca una nueva.
// `onEnd` se invoca una unica vez cuando la secuencia termina (para, p.ej., cerrar
// la ventana de aviso en el frontend).
export const startSoundLoop = (severidad = 'critica', origen, veces = 3, onEnd) => {
  stopSoundLoop();
  let contador = 0;
  const reproducir = () => {
    contador += 1;
    playNotificationSound(severidad, origen);
    if (contador >= veces) {
      stopSoundLoop();
      if (typeof onEnd === 'function') onEnd();
    }
  };
  reproducir();
  if (contador < veces) {
    loopInterval = setInterval(reproducir, 3000);
  }
};

export const stopSoundLoop = () => {
  if (loopInterval) {
    clearInterval(loopInterval);
    loopInterval = null;
  }
};
